import { render, staticRenderFns } from "./LimiteCompra.vue?vue&type=template&id=49cceec0&"
import script from "./LimiteCompra.vue?vue&type=script&lang=js&"
export * from "./LimiteCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports